import IMask from 'imask';
import { initForms } from './utils/sendform.js';



document.addEventListener('DOMContentLoaded', function(){

initForms();

const showModels = document.querySelector('.show-models');
const menuModels = document.querySelector('.menu-models');
if (showModels) {

        if (window.innerWidth > 768) {
            
      

        showModels.addEventListener('mouseover',()=>{
            menuModels.classList.add('active');
        });
        showModels.addEventListener('click',()=>{
            menuModels.classList.toggle('active');
        });

         menuModels.addEventListener('mouseleave',()=>{
            menuModels.classList.remove('active');
        });
    }
    else {
           showModels.addEventListener('click',()=>{
            menuModels.classList.toggle('active');
        });

       
    }


}



class ImageSorter {
    constructor(imageElement) {
        this.image = imageElement;
        this.sortValue = parseInt(this.image.dataset.sort) || 0;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.minSwipeDistance = 50; // минимальное расстояние для свайпа
        this.totalImages = 0;
        this.thumbs = document.querySelectorAll('.main-3d-thumbs img');
        console.log(this.thumbs)

        this.init();
    }
    
    init() {

        this.thumbs.forEach((ctx)=>{
            ctx.addEventListener('click',()=>{
             this.image.dataset.typenumber =   ctx.dataset.typenumber; 
                this.updateImageSrc();
            });
        });



        // Для мобильных устройств
        this.image.addEventListener('touchstart', (e) => this.handleTouchStart(e));
        this.image.addEventListener('touchend', (e) => this.handleTouchEnd(e));
        
        // Для десктопа (клики)
        this.image.addEventListener('click', (e) => this.handleClick(e));
        // this.image.addEventListener('wheel', (e) => this.handleClick(e));
        
        // Для десктопа (свайпы мышью)
        this.image.addEventListener('mousedown', (e) => this.handleMouseDown(e));
        this.image.addEventListener('mouseup', (e) => this.handleMouseUp(e));
    }
    
    handleTouchStart(e) {
        this.touchStartX = e.changedTouches[0].screenX;
    }
    
    handleTouchEnd(e) {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
    }
    
    handleMouseDown(e) {
        this.touchStartX = e.screenX;
    }
    
    handleMouseUp(e) {
        this.touchEndX = e.screenX;
        this.handleSwipe();
    }

  

    
    handleClick(e) {
        // Определяем сторону клика относительно центра изображения
        const rect = this.image.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const centerX = rect.width / 2;
        
        if (clickX < centerX) {
            // Клик слева - уменьшаем
            this.updateSort(-1);
        } else {
            // Клик справа - увеличиваем
            this.updateSort(1);
        }
    }
    
    handleSwipe() {
        const swipeDistance = this.touchEndX - this.touchStartX;
        
        if (Math.abs(swipeDistance) > this.minSwipeDistance) {
            if (swipeDistance > 0) {
                // Свайп вправо
                this.updateSort(1);
            } else {
                // Свайп влево
                this.updateSort(-1);
            }
        }
    }
    
    updateSort(direction) {
        const icon360 = document.querySelector('.icon-360');

        icon360.classList.add('hidden');
        
        if (this.sortValue < 1) {
            // console.log(parseInt(this.totalImages));
         this.sortValue = this.totalImages;
        }


       this.sortValue += direction;

       this.image.dataset.sort = parseInt(this.sortValue);
        
        // Опционально: обновляем src изображения
        this.updateImageSrc();
        
        // Вызываем кастомное событие
        this.image.dispatchEvent(new CustomEvent('sortChanged', {
            detail: { sort: this.sortValue, direction: direction }
        }));
        
   
    }
    
    updateImageSrc() {
            const sort =  this.image.dataset.sort;
            const carId =  this.image.dataset.carid;
            const typeNumber =  this.image.dataset.typenumber;
     
            fetch('/update-3d-image', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({ sort: sort,typenumber:typeNumber,car_id :carId })
        })
        .then(response => response.json())
        .then(data => {
        const src = '/'+data.imageOutput.image;
            this.image.src = src;
            this.image.dataset.sort = data.imageOutput.sort;
            this.sortValue = data.imageOutput.sort;
            this.totalImages = parseInt(data.totalImages);
            // console.log(  this.totalImages )
            
        })
        .catch(error => {
            console.error('Ошибка:', error);
            alert('Ошибка');
        });
    }





}

  const imageElement = document.getElementById('carImage');
    if (imageElement) {
        new ImageSorter(imageElement);
    }







const hamburger = document.querySelector('.hamb');
const header = document.querySelector('header');

hamburger.addEventListener('click',()=>{

if (menuModels.classList.contains('active')) {
    menuModels.classList.remove('active');
    // Ваш код здесь
}

    hamburger.classList.toggle('active');
    header.classList.toggle('active');

})






const ajaxFormButs = document.querySelectorAll('.show-form');

if (ajaxFormButs.length > 0) {
    
    ajaxFormButs.forEach(function (el){

        el.addEventListener('click', function(e) {
            e.preventDefault();
            let id = this.dataset.id;
            let params = {};
            params.id = id;
            showLoadingIndicator();
            showAjaxForm('/get-car-form',params);




        })
    });



}


function showAjaxForm(url_path,inputData) {




    fetch(url_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            'Accept': 'application/json'
        },
        body: JSON.stringify(inputData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        if (data.success) {
            // Вставляем полученный HTML
            // document.getElementById('form-container').innerHTML = data.html;
            const body = document.querySelector('body');
                const oldFrom = body.querySelector('.ajax-form');
                if (oldFrom) {
                    oldFrom.remove();
                }


               body.insertAdjacentHTML('beforeend', data.html);
               hideLoadingIndicator();
               initForms();
            // Инициализируем обработчики для новой формы
            // initializeFormHandlers();
            initCloseAjaxForm(body);
            // Скрываем индикатор загрузки
            // hideLoadingIndicator();
        } else {
            showError(data.message);
        }
    })
    .catch(error => {
        console.error('Ошибка:', error);
        // showError('Произошла ошибка при загрузке формы');
        // hideLoadingIndicator();
    });
}
function initCloseAjaxForm(body) {
  const close = () => {
        body.querySelector('.ajax-form')?.remove();
        body.querySelector('.form-bg')?.remove();
    };
    
    body.querySelector('.close')?.addEventListener('click', close);
    body.querySelector('.form-bg')?.addEventListener('click', close);

}

function showLoadingIndicator() {
    const loader = document.querySelector('.loader');
    loader.classList.add('active');
}
function hideLoadingIndicator() {
    const loader = document.querySelector('.loader');
    loader.classList.remove('active');
}


const toTop = document.querySelector('.to-top');

if (toTop) {
    toTop.addEventListener('click',()=>{
 window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}












});
